import React, { useEffect } from "react";
import TableContents from "components/BasicTable";
import { Box, Button, Center, Container, Flex, Input } from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { userAnalyticRequest } from "services/request";
import axiosInstance from "services/httpService";
import { useQuery } from "react-query";
import { QUERY_KEYS } from "utils/constants";
import dayjs from "dayjs";

const MonthlyDownloads = () => {
  const history = useNavigate();
  const [dateFilter, setDateFilter] = React.useState("allTime");
  const [startDate, setStartDate] = React.useState("");
  const [searchParams] = useSearchParams();
  const [endDate, setEndDate] = React.useState("");
  const [dateIndex, setDateIndex] = React.useState(0);

  const makeAPICall = async ({ queryKey }) => {
    const date = queryKey[1];
    const page = queryKey[2];
    const url = userAnalyticRequest.DOWNLOAD_HISTORY + `?date=${date}&page=${page}`;
    const res = await axiosInstance.get(url);
    return res.data;
  };

  const { data: downloadDetails = {}, isLoading } = useQuery(
    [QUERY_KEYS.DOWNLOAD_HISTORY, dateFilter],
    makeAPICall,
  );

  const Summary = downloadDetails.data;

  const COLUMNS = [
    {
      Header: "Script Name",
      accessor: "name",
    },
    {
      Header: "Number of Downloads",
      accessor: "totalDownloadCount",
    },
    {
      Header: "Updated On",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.lastUpdatedAt).format("MMM D YYYY")}</div>;
      },
    },
  ];
  useEffect(() => {
    if (startDate.length === 10 && endDate.length === 10) {
      const concatenatedDate = startDate + "," + endDate;
      setDateFilter(concatenatedDate);
      setDateIndex(10);
      handleDateFilter(dateFilter);
    }
  }, [startDate, endDate]);

  const handleDateFilter = (newDateRange) => {
    searchParams.set("date", String(newDateRange));
  };
  const dateFilterData = [
    {
      name: "All Time",
      value: "allTime",
    },
    {
      name: "Year",
      value: "thisYear",
    },
    {
      name: "Month",
      value: "thisMonth",
    },
    {
      name: "Week",
      value: "thisWeek",
    },
    {
      name: "Day",
      value: "today",
    },
  ];

  return (
    <Container mt="4" maxW="container.xl">
      <Button
        variant="secondary"
        onClick={() => {
          history(-1);
        }}
      >
        Back
      </Button>

      <Box p={"0 10px"} mt="2">
        <Box mb="20px" fontSize="30px" textAlign="center">
          Download History
        </Box>
        <Box
          m="2rem 0rem"
          display={{ base: "block", md: "flex", lg: "flex" }}
          alignItems="center"
          gap={5}
        >
          <Flex border="1px solid #E0E6DD" display="inline-flex" alignItems="stretch" height="42px">
            {dateFilterData.map((item, index: number) => (
              <Button
                key={index}
                _hover={{ border: "1px solid #005aff" }}
                bg={dateIndex === index ? "#1f74cf" : "white"}
                p={{ base: "15px 12px", md: "20px, 20px", lg: "20px, 20px" }}
                mb={{
                  base: "10px",
                  md: "0",
                  lg: "0",
                }}
                cursor={dateIndex === index ? "default" : "pointer"}
                pointerEvents={dateIndex === index ? "none" : "auto"}
                color={dateIndex === index ? "white" : "black"}
                onClick={() => {
                  setDateFilter(item.value);
                  setDateIndex(index);
                  setStartDate("");
                  setEndDate("");
                  handleDateFilter(dateFilter);
                }}
              >
                {item.name}
              </Button>
            ))}
          </Flex>
          <Flex
            mt={{ base: "20px", md: "0", lg: "0" }}
            width="19rem"
            gap={2}
            cursor={"pointer"}
            color={dateIndex === 10 ? "white" : "black"}
          >
            <Input
              height="42.5px"
              placeholder={"Select Start Date"}
              size="sm"
              color={dateIndex === 10 ? "white" : "black"}
              bg={dateIndex === 10 ? "#1f74cf" : "white"}
              borderRadius={dateIndex === 10 ? "md" : ""}
              type={"date"}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />
            <Center color="black" pointerEvents="none">
              <ArrowForwardIcon pointerEvents="none" />
            </Center>
            <Input
              height="42.5px"
              placeholder={"Select Start Date"}
              size="sm"
              color={dateIndex === 10 ? "white" : "black"}
              bg={dateIndex === 10 ? "#1f74cf" : "white"}
              borderRadius={dateIndex === 10 ? "md" : ""}
              type={"date"}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
            />
          </Flex>
        </Box>
        <TableContents columns={COLUMNS} data={Summary} loading={isLoading} />
      </Box>
    </Container>
  );
};

export default MonthlyDownloads;
